module.exports = __WEBPACK_EXTERNAL_MODULE__670__;